import { useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

import { useLocalStorage } from '../../services/hooks/useLocalStorage';

//import loadingIcon from '../../img/loading.gif';

const useStyles = makeStyles({
    loading: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& h1': {
            width: '100%',
            textAlign: 'center',
            fontSize: '1.5em',
            fontWeight: '400',
            margin: '0'
        },
        '& h2': {
            width: '100%',
            textAlign: 'center',
            fontSize: '1.0em',
            fontWeight: 'normal',
            margin: '8px 0',
            whiteSpace: 'pre-wrap'
        }
    },
    loadingBackdrop: {
        background: '#00000080',
        zIndex: '100'
    },
    container: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        margin: '0'
    },
    button: {
    },
    loadingCard: {
        width: '576px',
        height: '80px',
        borderRadius: '24px',
        border: '1px solid #CCCCCC',
        background: 'white'
    },
    loadingContainer: {
        margin: '10px 32px'
    },
    loadingText: {
        color: '#323232',
        fontSize: '22px',
        textAlign: 'center',
        fontFamily: 'helvetica'
    },
    loadingBarBackground: {
        background: 'linear-gradient(#8E5EF4 0 0) left -300px top 0 / 296px 20px no-repeat #B9A8DE',
        borderRadius: '10px',
        height: '6px',
        margin: '8px 0',
        animation: '$loading 2s infinite linear'
    },
    loadingSubtext: {
        color: '#323232',
        fontSize: '12px',
        fontFamily: 'helvetica',
        textAlign: 'left'
    },
    '@keyframes loading': {
        '100%': {
            backgroundPosition: 'right -300px top 0'
        }
    }
});

const Loading = (props) => {
    const classes = useStyles();
    const [stratus] = useLocalStorage("stratus", false);
    const ns = stratus ? 'stratus' : 'scantrip';
    const { t } = useTranslation(ns);
    const clickData = useRef({ count: 0, lastClickTime: 0 })
    const text = props.text || t('Loading');
    const subtext = props.subtext || t('Please wait...');
    const CLICK_DELAY = 2000;
    const REQUIRED_CLICKS = 5;
    let h1 = '';
    let h2 = '';
    let loadingBackgroundClass = classes.loading;
    if (props.hideIcon) {
        h1 = classes.h1;
        h2 = classes.h2;
    } else {
        loadingBackgroundClass += ` ${classes.loadingBackdrop}`
    }

    const handleClick = () => {
        if (!props.clickFunction) {
            return
        }
        const now = Date.now();
        if (now - clickData.current.lastClickTime > CLICK_DELAY) {
            clickData.current.count = 0;
        }
        clickData.current.count += 1;
        clickData.current.lastClickTime = now;
        if (clickData.current.count === REQUIRED_CLICKS) {
            props.clickFunction();
            clickData.current.count = 0;
        }
    }

    const MFPLoading = (classes, text, subtext) => {
        return (
            <div className={classes.loadingCard} onClick={handleClick}>
                <div className={classes.loadingContainer}>
                    <div className={classes.loadingText}>{text}</div>
                    <div className={classes.loadingBarBackground}></div>
                    <div className={classes.loadingSubtext}>{subtext}</div>
                </div>
            </div>
        )
    }

    return (
        <div className={loadingBackgroundClass} >
            {props.hideIcon ?
                <>
                    <h1 className={h1}>{text}</h1>
                    <h2 className={h2}>{subtext}</h2>
                </> :
                MFPLoading(classes, text, subtext)
            }
            <div className={classes.button}>{props.button}</div>
        </div>
    )
}

export default Loading;